// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-detail-dashboard {
  --dashboard-bg: rgba(248, 250, 252, 0.95);
  --card-bg: rgba(255, 255, 255, 0.95);
  --field-bg: rgba(248, 250, 252, 0.7);
  --field-hover-bg: rgba(255, 255, 255, 0.9);
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --border-color: rgba(255, 255, 255, 0.3);
  --field-border: #e2e8f0;
  --field-border-hover: #667eea;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  background: var(--dashboard-bg);
  backdrop-filter: blur(10px);
  min-height: 100vh;
}
html[data-coreui-theme=dark] .product-detail-dashboard {
  --dashboard-bg: rgba(30, 30, 47, 0.95);
  --card-bg: rgba(33, 38, 49, 0.95);
  --field-bg: rgba(44, 48, 52, 0.7);
  --field-hover-bg: rgba(44, 48, 52, 0.9);
  --text-primary: #fff;
  --text-secondary: #8a93a2;
  --border-color: rgba(255, 255, 255, 0.1);
  --field-border: #333;
  --field-border-hover: #667eea;
}

.dashboard-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 0.75rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  color: white;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.2);
  position: relative;
  overflow: hidden;
}

.dashboard-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4);
  background-size: 300% 100%;
  animation: gradientShift 3s ease-in-out infinite;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title h2 {
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 0.25rem 0;
}

.header-title p {
  font-size: 1rem;
  opacity: 0.9;
  margin: 0;
}

.metadata-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.15);
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  backdrop-filter: blur(10px);
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  padding: 2rem;
}

.loading-card {
  background: var(--card-bg);
  backdrop-filter: blur(20px);
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--border-color);
}

.primary-spinner {
  color: #667eea;
  width: 2.5rem;
  height: 2.5rem;
}

.loading-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 1rem 0 0.5rem 0;
}

.loading-subtitle {
  color: var(--text-secondary);
  margin: 0.5rem 0;
}

.loading-progress {
  width: 100%;
  height: 3px;
  background: #e2e8f0;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 1rem;
}
html[data-coreui-theme=dark] .loading-progress {
  background: #333;
}

.error-container {
  padding: 2rem;
}

.error-alert {
  border: none;
  border-radius: 0.75rem;
  background: rgba(239, 68, 68, 0.1);
  border-left: 4px solid #ef4444;
  backdrop-filter: blur(10px);
  padding: 1rem 1.25rem;
}

.error-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.error-icon {
  font-size: 1.5rem;
}

.error-text {
  flex: 1 1;
}

.error-title {
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
}

.error-message {
  margin: 0;
  color: var(--text-secondary);
}

.intelligence-card {
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  background: var(--card-bg);
  backdrop-filter: blur(20px);
}

.card-header-premium {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}
.card-header-premium:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%);
}
.card-header-premium.collapsible-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-header-premium.collapsible-header .collapse-button {
  color: white;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  font-size: 1.25rem;
  transition: transform 0.3s ease;
}
.card-header-premium.collapsible-header .collapse-button:hover {
  color: rgba(255, 255, 255, 0.8);
  transform: scale(1.1);
}
.card-header-premium.collapsible-header .collapse-button:focus {
  box-shadow: none;
}

.primary-card .card-header-premium {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.manufacturing-card .card-header-premium {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.commercial-card .card-header-premium {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.header-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.section-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
}

.section-subtitle {
  font-size: 0.875rem;
  opacity: 0.85;
  font-style: italic;
  margin: 0;
  color: white !important;
}

.header-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.15);
  padding: 0.375rem 0.75rem;
  border-radius: 0.5rem;
  backdrop-filter: blur(10px);
}

.status-indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
}

.status-text {
  font-size: 0.8rem;
  font-weight: 500;
}

.card-body-premium {
  padding: 1.5rem;
  transition: all 0.3s ease;
  overflow: hidden;
}
.card-body-premium.collapsed {
  max-height: 0;
  padding: 0 1.5rem;
  opacity: 0;
}
.card-body-premium.expanded {
  max-height: none;
  opacity: 1;
}
.card-body-premium .order-item:last-child {
  margin-bottom: 0;
}

.commercial-card .card-body-premium.expanded {
  max-height: 600px;
  overflow-y: auto;
  padding-right: 1rem;
  scrollbar-width: thin;
  scrollbar-color: #667eea rgba(102, 126, 234, 0.1);
}
.commercial-card .card-body-premium.expanded::-webkit-scrollbar {
  width: 8px;
}
.commercial-card .card-body-premium.expanded::-webkit-scrollbar-track {
  background: rgba(102, 126, 234, 0.1);
  border-radius: 4px;
}
.commercial-card .card-body-premium.expanded::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}
.commercial-card .card-body-premium.expanded::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);
}

.order-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}
@media (max-width: 1200px) {
  .order-details-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .order-details-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

@media (max-width: 1200px) {
  .order-details-grid .order-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (max-width: 768px) {
  .order-details-grid .order-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-item {
    padding: 1rem;
  }
  .order-item .order-header {
    flex-direction: column;
    gap: 0.75rem;
    text-align: center;
  }
}
.field-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.data-field {
  background: var(--field-bg);
  backdrop-filter: blur(10px);
  border-radius: 0.5rem;
  padding: 1rem;
  border-left: 3px solid var(--field-border);
  transition: all 0.2s ease;
  border: 1px solid var(--border-color);
}

.data-field:hover {
  background: var(--field-hover-bg);
  border-left-color: var(--field-border-hover);
  transform: translateY(-1px);
}

.field-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.field-icon {
  color: var(--text-secondary);
  font-size: 0.75rem;
}

.field-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0;
}

.field-value {
  min-height: 1.25rem;
  display: flex;
  align-items: center;
}

.value-text {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-primary);
  line-height: 1.4;
}

.value-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
  backdrop-filter: blur(10px);
}

.badge-material {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
}

.badge-weave {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
}

.badge-customer {
  background: linear-gradient(135deg, #06b6d4, #0891b2);
}

.badge-supplier {
  background: linear-gradient(135deg, #10b981, #059669);
}

.badge-status {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.badge-quantity, .badge-density, .badge-threads {
  background: linear-gradient(135deg, #64748b, #475569);
}

.badge-weight {
  background: linear-gradient(135deg, #ec4899, #db2777);
}

.badge-default {
  background: linear-gradient(135deg, #6366f1, #4f46e5);
}

.order-details-grid .order-col {
  flex: 1 1;
  min-width: 0;
  margin-bottom: 1rem;
}
@media (max-width: 1200px) {
  .order-details-grid .order-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (max-width: 768px) {
  .order-details-grid .order-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.order-item {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 0.75rem;
  border: 1px solid rgba(102, 126, 234, 0.1);
  transition: all 0.3s ease;
}
.order-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(102, 126, 234, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.1);
}
.order-item:last-child {
  margin-bottom: 0;
}
.order-item .order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
  border-radius: 0.5rem;
  border-left: 4px solid #667eea;
}
.order-item .order-header .order-title {
  margin: 0;
  font-weight: 600;
  color: #495057;
  font-size: 1.1rem;
}
.order-item .order-header .order-status-badge {
  font-size: 0.75rem;
  padding: 0.5rem 1rem;
  border-radius: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.order-item .order-header .order-status-badge.badge-warning {
  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
  color: #212529;
}
.order-item .order-header .order-status-badge.badge-success {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}
.order-item .order-header .order-status-badge.badge-danger {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}
.order-item .order-header .order-status-badge.badge-secondary {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
}
.order-item .order-divider {
  margin: 2rem 0;
  border: none;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(102, 126, 234, 0.2) 50%, transparent 100%);
}

.section-subtitle {
  margin: 0;
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 400;
  opacity: 0.8;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@media (max-width: 768px) {
  .product-detail-dashboard {
    padding: 1rem;
  }
  .dashboard-header {
    padding: 1rem;
  }
  .header-content {
    flex-direction: column;
    gap: 0.75rem;
    text-align: center;
  }
  .card-header-premium, .card-body-premium {
    padding: 1rem;
  }
  .field-group {
    gap: 0.75rem;
  }
  .data-field {
    padding: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProductDetailCard/ProductDetailCard.scss"],"names":[],"mappings":"AACE;EACE,yCAAA;EACA,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,uBAAA;EACA,yBAAA;EACA,wCAAA;EACA,uBAAA;EACA,6BAAA;EAcA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,2BAAA;EACA,iBAAA;AAbJ;AAJI;EACE,sCAAA;EACA,iCAAA;EACA,iCAAA;EACA,uCAAA;EACA,oBAAA;EACA,yBAAA;EACA,wCAAA;EACA,oBAAA;EACA,6BAAA;AAMN;;AAKE;EACE,6DAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;;AAKE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,sEAAA;EACA,0BAAA;EACA,gDAAA;AAFJ;;AAKE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAFJ;;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;AAFJ;;AAKE;EACE,eAAA;EACA,YAAA;EACA,SAAA;AAFJ;;AAKE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qCAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AAFJ;;AAKE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAFJ;;AAKE;EACE,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,qCAAA;AAFJ;;AAKE;EACE,cAAA;EACA,aAAA;EACA,cAAA;AAFJ;;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;AAFJ;;AAKE;EACE,4BAAA;EACA,gBAAA;AAFJ;;AAKE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;AAII;EACE,gBAAA;AAFN;;AAME;EACE,aAAA;AAHJ;;AAME;EACE,YAAA;EACA,sBAAA;EACA,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qBAAA;AAHJ;;AAME;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAHJ;;AAME;EACE,iBAAA;AAHJ;;AAME;EACE,SAAA;AAHJ;;AAME;EACE,oBAAA;EACA,0BAAA;AAHJ;;AAME;EACE,SAAA;EACA,4BAAA;AAHJ;;AAME;EACE,qCAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,0CAAA;EACA,0BAAA;EACA,2BAAA;AAHJ;;AAME;EACE,uBAAA;EACA,iDAAA;EACA,eAAA;EACA,yBAAA;AAHJ;AAKI;EACE,8FAAA;AAHN;AAMI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAJN;AAMM;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;AAJR;AAMQ;EACE,+BAAA;EACA,qBAAA;AAJV;AAOQ;EACE,gBAAA;AALV;;AAWE;EACE,6DAAA;EACA,YAAA;AARJ;;AAWE;EACE,6DAAA;EACA,YAAA;AARJ;;AAWE;EACE,6DAAA;EACA,YAAA;AARJ;;AAWE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AARJ;;AAWE;EACE,aAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;AARJ;;AAWE;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;AARJ;;AAWE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;AARJ;;AAWE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qCAAA;EACA,yBAAA;EACA,qBAAA;EACA,2BAAA;AARJ;;AAWE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AARJ;;AAWE;EACE,iBAAA;EACA,gBAAA;AARJ;;AAWE;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;AARJ;AAUI;EACE,aAAA;EACA,iBAAA;EACA,UAAA;AARN;AAWI;EACE,gBAAA;EACA,UAAA;AATN;AAaI;EACE,gBAAA;AAXN;;AAiBI;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EAsBA,qBAAA;EACA,iDAAA;AAnCN;AAeM;EACE,UAAA;AAbR;AAgBM;EACE,oCAAA;EACA,kBAAA;AAdR;AAiBM;EACE,6DAAA;EACA,kBAAA;AAfR;AAiBQ;EACE,6DAAA;AAfV;;AA0BE;EACE,aAAA;EACA,2DAAA;EACA,WAAA;AAvBJ;AAyBI;EALF;IAMI,qCAAA;EAtBJ;AACF;AAwBI;EATF;IAUI,0BAAA;IACA,SAAA;EArBJ;AACF;;AAyBE;EAEI;IACE,aAAA;IACA,cAAA;EAvBN;AACF;AA2BE;EAEI;IACE,cAAA;IACA,eAAA;EA1BN;EA8BE;IACE,aAAA;EA5BJ;EA8BI;IACE,sBAAA;IACA,YAAA;IACA,kBAAA;EA5BN;AACF;AAgCE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA9BJ;;AAiCE;EACE,2BAAA;EACA,2BAAA;EACA,qBAAA;EACA,aAAA;EACA,0CAAA;EACA,yBAAA;EACA,qCAAA;AA9BJ;;AAiCE;EACE,iCAAA;EACA,4CAAA;EACA,2BAAA;AA9BJ;;AAiCE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AA9BJ;;AAiCE;EACE,4BAAA;EACA,kBAAA;AA9BJ;;AAiCE;EACE,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;AA9BJ;;AAiCE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AA9BJ;;AAiCE;EACE,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AA9BJ;;AAiCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,2BAAA;AA9BJ;;AAiCE;EAAkB,qDAAA;AA7BpB;;AA8BE;EAAe,qDAAA;AA1BjB;;AA2BE;EAAkB,qDAAA;AAvBpB;;AAwBE;EAAkB,qDAAA;AApBpB;;AAqBE;EAAgB,qDAAA;AAjBlB;;AAkBE;EACE,qDAAA;AAfJ;;AAiBE;EAAgB,qDAAA;AAblB;;AAcE;EACE,qDAAA;AAXJ;;AAeI;EACE,SAAA;EACA,YAAA;EACA,mBAAA;AAZN;AAcM;EALF;IAMI,aAAA;IACA,cAAA;EAXN;AACF;AAaM;EAVF;IAWI,cAAA;IACA,eAAA;EAVN;AACF;;AAeE;EACE,mBAAA;EACA,eAAA;EACA,qCAAA;EACA,sBAAA;EACA,0CAAA;EACA,yBAAA;AAZJ;AAcI;EACE,qCAAA;EACA,sCAAA;EACA,2BAAA;EACA,+CAAA;AAZN;AAeI;EACE,gBAAA;AAbN;AAgBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gGAAA;EACA,qBAAA;EACA,8BAAA;AAdN;AAgBM;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAdR;AAiBM;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAfR;AAiBQ;EACE,6DAAA;EACA,cAAA;AAfV;AAkBQ;EACE,6DAAA;EACA,YAAA;AAhBV;AAmBQ;EACE,6DAAA;EACA,YAAA;AAjBV;AAoBQ;EACE,6DAAA;EACA,YAAA;AAlBV;AAuBI;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,kGAAA;AArBN;;AA0BE;EACE,SAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAvBJ;;AA0BE;EACE;IAAK,2BAAA;EAtBP;EAuBE;IAAM,6BAAA;EApBR;EAqBE;IAAO,2BAAA;EAlBT;AACF;AAoBE;EACE;IAAK,4BAAA;EAjBP;EAkBE;IAAO,2BAAA;EAfT;AACF;AAiBE;EACE;IACE,aAAA;EAfJ;EAiBE;IACE,aAAA;EAfJ;EAiBE;IACE,sBAAA;IACA,YAAA;IACA,kBAAA;EAfJ;EAiBE;IACE,aAAA;EAfJ;EAiBE;IACE,YAAA;EAfJ;EAiBE;IACE,gBAAA;EAfJ;AACF","sourcesContent":["\n  .product-detail-dashboard {\n    --dashboard-bg: rgba(248, 250, 252, 0.95);\n    --card-bg: rgba(255, 255, 255, 0.95);\n    --field-bg: rgba(248, 250, 252, 0.7);\n    --field-hover-bg: rgba(255, 255, 255, 0.9);\n    --text-primary: #1e293b;\n    --text-secondary: #64748b;\n    --border-color: rgba(255, 255, 255, 0.3);\n    --field-border: #e2e8f0;\n    --field-border-hover: #667eea;\n\n    html[data-coreui-theme=\"dark\"] & {\n      --dashboard-bg: rgba(30, 30, 47, 0.95);\n      --card-bg: rgba(33, 38, 49, 0.95);\n      --field-bg: rgba(44, 48, 52, 0.7);\n      --field-hover-bg: rgba(44, 48, 52, 0.9);\n      --text-primary: #fff;\n      --text-secondary: #8a93a2;\n      --border-color: rgba(255, 255, 255, 0.1);\n      --field-border: #333;\n      --field-border-hover: #667eea;\n    }\n\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 1.5rem;\n    background: var(--dashboard-bg);\n    backdrop-filter: blur(10px);\n    min-height: 100vh;\n  }\n\n  .dashboard-header {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-radius: 0.75rem;\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n    color: white;\n    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.2);\n    position: relative;\n    overflow: hidden;\n  }\n\n  .dashboard-header::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(90deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4);\n    background-size: 300% 100%;\n    animation: gradientShift 3s ease-in-out infinite;\n  }\n\n  .header-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .header-title h2 {\n    font-size: 1.75rem;\n    font-weight: 700;\n    margin: 0 0 0.25rem 0;\n  }\n\n  .header-title p {\n    font-size: 1rem;\n    opacity: 0.9;\n    margin: 0;\n  }\n\n  .metadata-item {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: rgba(255, 255, 255, 0.15);\n    padding: 0.5rem 0.75rem;\n    border-radius: 0.5rem;\n    font-size: 0.875rem;\n    backdrop-filter: blur(10px);\n  }\n\n  .loading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 50vh;\n    padding: 2rem;\n  }\n\n  .loading-card {\n    background: var(--card-bg);\n    backdrop-filter: blur(20px);\n    border-radius: 1rem;\n    padding: 2rem;\n    text-align: center;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n    border: 1px solid var(--border-color);\n  }\n\n  .primary-spinner {\n    color: #667eea;\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n\n  .loading-title {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin: 1rem 0 0.5rem 0;\n  }\n\n  .loading-subtitle {\n    color: var(--text-secondary);\n    margin: 0.5rem 0;\n  }\n\n  .loading-progress {\n    width: 100%;\n    height: 3px;\n    background: #e2e8f0;\n    border-radius: 20px;\n    overflow: hidden;\n    margin-top: 1rem;\n\n    html[data-coreui-theme=\"dark\"] & {\n      background: #333;\n    }\n  }\n\n  .error-container {\n    padding: 2rem;\n  }\n\n  .error-alert {\n    border: none;\n    border-radius: 0.75rem;\n    background: rgba(239, 68, 68, 0.1);\n    border-left: 4px solid #ef4444;\n    backdrop-filter: blur(10px);\n    padding: 1rem 1.25rem;\n  }\n\n  .error-content {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .error-icon {\n    font-size: 1.5rem;\n  }\n\n  .error-text {\n    flex: 1;\n  }\n\n  .error-title {\n    margin: 0 0 0.5rem 0;\n    color: var(--text-primary);\n  }\n\n  .error-message {\n    margin: 0;\n    color: var(--text-secondary);\n  }\n\n  .intelligence-card {\n    border: 1px solid var(--border-color);\n    border-radius: 0.75rem;\n    margin-bottom: 1.5rem;\n    overflow: hidden;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);\n    background: var(--card-bg);\n    backdrop-filter: blur(20px);\n  }\n\n  .card-header-premium {\n    padding: 1.25rem 1.5rem;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    cursor: pointer;\n    transition: all 0.3s ease;\n    \n    &:hover {\n      background: linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%);\n    }\n    \n    &.collapsible-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      \n      .collapse-button {\n        color: white;\n        padding: 0;\n        margin: 0;\n        border: none;\n        background: transparent;\n        font-size: 1.25rem;\n        transition: transform 0.3s ease;\n        \n        &:hover {\n          color: rgba(255, 255, 255, 0.8);\n          transform: scale(1.1);\n        }\n        \n        &:focus {\n          box-shadow: none;\n        }\n      }\n    }\n  }\n\n  .primary-card .card-header-premium {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n  }\n\n  .manufacturing-card .card-header-premium {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n  }\n\n  .commercial-card .card-header-premium {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n  }\n\n  .header-section {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n  }\n\n  .section-icon {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.125rem;\n    background: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(10px);\n  }\n\n  .section-title {\n    font-size: 1.125rem;\n    font-weight: 600;\n    margin: 0 0 0.25rem 0;\n  }\n\n  .section-subtitle {\n    font-size: 0.875rem;\n    opacity: 0.85;\n    font-style: italic;\n    margin: 0;\n    color: white !important;\n  }\n\n  .header-badge {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: rgba(255, 255, 255, 0.15);\n    padding: 0.375rem 0.75rem;\n    border-radius: 0.5rem;\n    backdrop-filter: blur(10px);\n  }\n\n  .status-indicator {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #22c55e;\n  }\n\n  .status-text {\n    font-size: 0.8rem;\n    font-weight: 500;\n  }\n\n  .card-body-premium {\n    padding: 1.5rem;\n    transition: all 0.3s ease;\n    overflow: hidden;\n    \n    &.collapsed {\n      max-height: 0;\n      padding: 0 1.5rem;\n      opacity: 0;\n    }\n    \n    &.expanded {\n      max-height: none;\n      opacity: 1;\n    }\n    \n    // Sipariş detayları için özel scroll ayarları\n    .order-item:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  // Sipariş detayları için scroll container\n  .commercial-card .card-body-premium {\n    &.expanded {\n      max-height: 600px;\n      overflow-y: auto;\n      padding-right: 1rem; // Scroll bar için ekstra padding\n      \n      // Webkit scrollbar stilleri\n      &::-webkit-scrollbar {\n        width: 8px;\n      }\n      \n      &::-webkit-scrollbar-track {\n        background: rgba(102, 126, 234, 0.1);\n        border-radius: 4px;\n      }\n      \n      &::-webkit-scrollbar-thumb {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        border-radius: 4px;\n        \n        &:hover {\n          background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);\n        }\n      }\n      \n      // Firefox scrollbar stilleri\n      scrollbar-width: thin;\n      scrollbar-color: #667eea rgba(102, 126, 234, 0.1);\n    }\n  }\n\n  // Sipariş detayları için daha iyi grid layout\n  .order-details-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1.5rem;\n    \n    @media (max-width: 1200px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    \n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n      gap: 1rem;\n    }\n  }\n\n  // Sipariş detayları için daha iyi responsive tasarım\n  @media (max-width: 1200px) {\n    .order-details-grid {\n      .order-col {\n        flex: 0 0 50%;\n        max-width: 50%;\n      }\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .order-details-grid {\n      .order-col {\n        flex: 0 0 100%;\n        max-width: 100%;\n      }\n    }\n    \n    .order-item {\n      padding: 1rem;\n      \n      .order-header {\n        flex-direction: column;\n        gap: 0.75rem;\n        text-align: center;\n      }\n    }\n  }\n\n  .field-group {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .data-field {\n    background: var(--field-bg);\n    backdrop-filter: blur(10px);\n    border-radius: 0.5rem;\n    padding: 1rem;\n    border-left: 3px solid var(--field-border);\n    transition: all 0.2s ease;\n    border: 1px solid var(--border-color);\n  }\n\n  .data-field:hover {\n    background: var(--field-hover-bg);\n    border-left-color: var(--field-border-hover);\n    transform: translateY(-1px);\n  }\n\n  .field-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .field-icon {\n    color: var(--text-secondary);\n    font-size: 0.75rem;\n  }\n\n  .field-label {\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin: 0;\n  }\n\n  .field-value {\n    min-height: 1.25rem;\n    display: flex;\n    align-items: center;\n  }\n\n  .value-text {\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: var(--text-primary);\n    line-height: 1.4;\n  }\n\n  .value-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.25rem 0.5rem;\n    border-radius: 0.375rem;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: white;\n    backdrop-filter: blur(10px);\n  }\n\n  .badge-material { background: linear-gradient(135deg, #3b82f6, #1d4ed8); }\n  .badge-weave { background: linear-gradient(135deg, #8b5cf6, #7c3aed); }\n  .badge-customer { background: linear-gradient(135deg, #06b6d4, #0891b2); }\n  .badge-supplier { background: linear-gradient(135deg, #10b981, #059669); }\n  .badge-status { background: linear-gradient(135deg, #f59e0b, #d97706); }\n  .badge-quantity, .badge-density, .badge-threads { \n    background: linear-gradient(135deg, #64748b, #475569); \n  }\n  .badge-weight { background: linear-gradient(135deg, #ec4899, #db2777); }\n  .badge-default { \n    background: linear-gradient(135deg, #6366f1, #4f46e5);\n  }\n\n  .order-details-grid {\n    .order-col {\n      flex: 1;\n      min-width: 0;\n      margin-bottom: 1rem;\n      \n      @media (max-width: 1200px) {\n        flex: 0 0 50%;\n        max-width: 50%;\n      }\n      \n      @media (max-width: 768px) {\n        flex: 0 0 100%;\n        max-width: 100%;\n      }\n    }\n  }\n\n  // Order items styling\n  .order-item {\n    margin-bottom: 2rem;\n    padding: 1.5rem;\n    background: rgba(255, 255, 255, 0.02);\n    border-radius: 0.75rem;\n    border: 1px solid rgba(102, 126, 234, 0.1);\n    transition: all 0.3s ease;\n    \n    &:hover {\n      background: rgba(255, 255, 255, 0.05);\n      border-color: rgba(102, 126, 234, 0.2);\n      transform: translateY(-2px);\n      box-shadow: 0 8px 25px rgba(102, 126, 234, 0.1);\n    }\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n    \n    .order-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 1.5rem;\n      padding: 1rem 1.25rem;\n      background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);\n      border-radius: 0.5rem;\n      border-left: 4px solid #667eea;\n      \n      .order-title {\n        margin: 0;\n        font-weight: 600;\n        color: #495057;\n        font-size: 1.1rem;\n      }\n      \n      .order-status-badge {\n        font-size: 0.75rem;\n        padding: 0.5rem 1rem;\n        border-radius: 1rem;\n        font-weight: 600;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        \n        &.badge-warning {\n          background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);\n          color: #212529;\n        }\n        \n        &.badge-success {\n          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n          color: white;\n        }\n        \n        &.badge-danger {\n          background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n          color: white;\n        }\n        \n        &.badge-secondary {\n          background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n          color: white;\n        }\n      }\n    }\n    \n    .order-divider {\n      margin: 2rem 0;\n      border: none;\n      height: 1px;\n      background: linear-gradient(90deg, transparent 0%, rgba(102, 126, 234, 0.2) 50%, transparent 100%);\n    }\n  }\n\n  // Section subtitle styling\n  .section-subtitle {\n    margin: 0;\n    font-size: 0.875rem;\n    color: #6c757d;\n    font-weight: 400;\n    opacity: 0.8;\n  }\n\n  @keyframes gradientShift {\n    0% { background-position: 0% 50%; }\n    50% { background-position: 100% 50%; }\n    100% { background-position: 0% 50%; }\n  }\n\n  @keyframes shimmer {\n    0% { transform: translateX(-100%); }\n    100% { transform: translateX(100%); }\n  }\n\n  @media (max-width: 768px) {\n    .product-detail-dashboard {\n      padding: 1rem;\n    }\n    .dashboard-header {\n      padding: 1rem;\n    }\n    .header-content {\n      flex-direction: column;\n      gap: 0.75rem;\n      text-align: center;\n    }\n    .card-header-premium, .card-body-premium {\n      padding: 1rem;\n    }\n    .field-group {\n      gap: 0.75rem;\n    }\n    .data-field {\n      padding: 0.75rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
